var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-count-chip",class:[("v-count-chip--" + (_vm.$props.type))]},[_vm._v(_vm._s(_vm.getChipText))])}
var staticRenderFns = []

export { render, staticRenderFns }